import { AppPublicKey } from "./schemas/config/index"
import apiTest from "./services/apiTest"

export const askForNotificationPermission = async () => {
  const permission = await Notification.requestPermission()
  return permission
}

export const registerServiceWorker = async ({ userId }) => {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    try {
      const registration = await navigator.serviceWorker.register(
        "/service-worker.js"
      )

      const subscription = await registration.pushManager.getSubscription()

      if (!subscription) {
        const newSubscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: AppPublicKey
        })

        const response = await apiTest.post("/create-subscription-push", {
          userId,
          auth: JSON.stringify(newSubscription)
        })
        return response
      }
    } catch (error) {
      console.error("Falha ao registrar o Service Worker:", error)
    }
  }
}
